import { gql } from "@apollo/client";

export const checkSweepstakesExists = gql`
  query CheckSweepstakes($id: SweepstakesSlug!) {
    sweepstakes(id: $id) {
      id
    }
  }
`;
